import { render, staticRenderFns } from "./InsertionOrderIndex.vue?vue&type=template&id=5f96addf&"
import script from "./InsertionOrderIndex.vue?vue&type=script&lang=js&"
export * from "./InsertionOrderIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports